import {DrawerProps} from '@mantine/core';
import {useParams} from "react-router-dom";
import {FormDrawer} from "./FormDrawer.tsx";
import {usePhase} from "../hooks/usePhase.ts";


export const EditFormDrawer = (props: DrawerProps) => {

    // Inside /playbooks/:id/phases/:phaseId, the param name for the Phase is :phaseId.
    const {id: playbookId, phaseId} = useParams();

    if (typeof phaseId === 'undefined') {
        throw new Error('phaseId is required parameter');
    }

    const {
        record,
        updateRecord,
    } = usePhase(phaseId);

    if (!record) return null;

    // Ensure playbookId is preserved from the route in case the record FK is ever missing.
    const seededRecord = {
        ...record,
        ...(playbookId ? {playbookId} : {}),
    };

    return (
        <FormDrawer
            record={seededRecord}
            handleSubmit={updateRecord}
            {...props}
        />
    )
};
